import * as React from "react";

function SvgIcons8Dashboard(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 4C9.383 4 4 9.383 4 16s5.383 12 12 12 12-5.383 12-12S22.617 4 16 4zm0 2c5.535 0 10 4.465 10 10s-4.465 10-10 10S6 21.535 6 16 10.465 6 16 6zm0 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-5.656 2.344c-.551 0-1 .449-1 1 0 .55.449 1 1 1 .55 0 1-.45 1-1 0-.551-.45-1-1-1zm10.594.312L16.5 14.062A1.999 1.999 0 0014 16a1.999 1.999 0 103.938-.5l4.437-4.438zM8 15c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm16 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-13.656 5.656c-.551 0-1 .45-1 1 0 .551.449 1 1 1 .55 0 1-.449 1-1 0-.55-.45-1-1-1zm11.312 0c-.55 0-1 .45-1 1 0 .551.45 1 1 1 .551 0 1-.449 1-1 0-.55-.449-1-1-1z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Dashboard);
